<template>
 <div >
    <FormulateForm
        @submit="signup"
    >
        <FormulateInput
            v-model="email"
            type="email"
            label="Your Email"
            name="email"
            validation="required"
            :wrapper-class="['signup_email']"
        />
        <!-- Note: Password length must match Backend requirements -->
        <FormulateInput
            v-model="password"
            type="password"
            label="Your Password"
            name="password"
            validation="required|min:5,length"
            :wrapper-class="['signup_password']"
        />
        <FormulateInput
            type="submit"
            label="Sign up"
            :wrapper-class="['signup_submit']"
        />
    </FormulateForm>
 </div>
</template>

<script>
import axios from 'axios'
import AuthService from '@/services/AuthService.js';

export default {
    name: 'LoginForm',
    data: function(){
        return {
            email: "",
            password: "",
            name: "",
            msg: ""
        }
    },
    methods: {
        async signup() {
            try {
                const credentials = {
                    email: this.email,
                    password: this.password,
                    //name: "" // Not required
                };
                const response_signup = await AuthService.signUp(credentials);
                this.msg = response_signup.msg;
                // Note:
                // Currently I have to call login bc backend does not send a token automatically
                const response_login = await AuthService.login(credentials);
                const token = response_login.token;
                this.msg = response_login.msg;
                this.$store.dispatch('login', { token });
                //this.$router.push('/');
                console.log(token)
            } catch (error) {
                this.msg = error.response.data.msg;
                console.log(this.msg)
            }
        }
    }
}
</script>
